import React from 'react';
import { Image, StyleSheet, Text, View } from '../base_components';
import Select from '../select';

import { styles, getButtonStyles } from './text_button';

const selectStyles = StyleSheet.create({
  select: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
  },
  image: {
    marginLeft: '1rem',
    height: '0.8rem',
    width: '0.8rem',
    transform: 'rotate(90deg)',
  },
});

const ARROW = require('../../assets/img/arrow_right_black.png');

type Props = {
  style?: any;
  textStyle?: any;
  type?: any;
  disabled?: boolean;
  options: any[];
  value: any;
  onChange: (value?: any) => void;
};
export default function SelectButton(props: Props) {
  const { style, textStyle, value } = props;
  const { button_extra, text_extra } = getButtonStyles(props);

  const text = props.options.find((opt) => opt.value === value)?.text ?? value;

  return (
    <View style={[styles.textButton, button_extra, style]}>
      <View style={styles.inner}>
        <Text style={[styles.text, text_extra, textStyle]}>{text}</Text>
        <Image style={selectStyles.image} source={ARROW} />
      </View>
      <Select
        style={[selectStyles.select, styles.text, textStyle]}
        options={props.options}
        value={props.value}
        onChange={props.onChange}
      />
    </View>
  );
}
